module.exports = flarum.core.compat['helpers/username'];